export const aboutData = {
  // Cycled by the typewriter after the words "HackDFW is", so each line has to
  // read as a complete sentence on its own. No event dates here on purpose.
  taglines: [
    "Back for 2027.",
    "a celebration of Dallas' entrepreneurial spirit.",
    "the Design Thinking Hackathon of Texas.",
    "the new career fair.",
    "your connection to tech in Dallas-Fort Worth.",
  ]
}
